var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{ref:"com-area-select",staticClass:"com-area-select"},[_c('el-cascader',_vm._g(_vm._b({attrs:{"props":_vm.props}},'el-cascader',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }